import { FC, ReactNode } from 'react';
import ActionButton from 'jbc-front/components/ActionButton';
import { Download, Print } from 'jbc-front/components/icons';
import { PdfModal } from 'jbc-front/components/presenters/ui/PdfModal';

import { Pdf } from './Pdf';
import styles from './Viewer.scss';

export type Viewer = {
  children: ReactNode;
};

const ViewerComponent: FC<Viewer> = ({ children }) => {
  return <PdfModal isOpen={true}>{children}</PdfModal>;
};

export type Header = {
  onClose: () => void;
  reportUrl?: string;
  title: string;
  hidePrint?: boolean;
  printDisabledReason?: string;
  onClickDownload: () => void;
};

export const Header: FC<Header> = ({
  onClose,
  reportUrl,
  title,
  hidePrint = false,
  printDisabledReason,
  onClickDownload
}) => {
  return (
    <PdfModal.Header>
      <PdfModal.Title>{title}</PdfModal.Title>
      <PdfModal.ToolContainer onClose={onClose}>
        {!hidePrint && (
          <>
            <PrintButton
              url={reportUrl}
              disabled={!reportUrl || !!printDisabledReason}
              disabledReason={printDisabledReason}
            />

            <ActionButton
              primary
              className={styles.button}
              disabled={!!printDisabledReason}
              onClick={onClickDownload}
              disabledReason={printDisabledReason}
              icon={<Download size={15} />}>
              ダウンロード
            </ActionButton>
          </>
        )}
      </PdfModal.ToolContainer>
    </PdfModal.Header>
  );
};

type PrintButtonProps = {
  url?: string;
  disabled: boolean;
  disabledReason?: string;
};

const PrintButton: FC<PrintButtonProps> = ({ url, disabled, disabledReason }) => {
  const handleClickPrint = () => {
    if (url) {
      const w = window.open(url, '', 'toolbar=0,menubar=0,location=0');
      if (w?.addEventListener) {
        w.addEventListener('load', () => {
          w.print();
        });
      }
    }
  };

  return (
    <ActionButton
      primary
      className={styles.button}
      onClick={handleClickPrint}
      icon={<Print size={15} />}
      disabled={disabled}
      disabledReason={disabledReason}>
      印刷
    </ActionButton>
  );
};

export const Viewer = Object.assign(ViewerComponent, { Header, Pdf });
